import { FileService } from './FileService';
import { IFileService } from './IFileService';

export const fileService: IFileService = new FileService();
